import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

export default {
  getHeaders () {
    const user = JSON.parse(sessionStorage.getItem('user'))

    return {
      id: user ? user.login : ''
    }
  },
  getHeadersForDownload () {
    const user = JSON.parse(sessionStorage.getItem('user'))

    return {
      id: user ? user.login : '',
      'content-type': 'text/plain'
    }
  },

  async getDepensesCarte (credentials) {
    return axios.post('/porteur/depensescarte', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getOperationsPorteur (credentials) {
    return axios.post('/porteur/operationsporteur', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getRelevesOperationsPorteur (credentials) {
    return axios.post('/porteur/relevesoperationsporteur', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getRelevesPorteur (credentials) {
    return axios.post('/porteur/relevesporteur', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async downloadRelevesPorteurs (credentials) {
    return axios.post('/porteur/downloadrelevesporteur', credentials, { responseType: 'blob', headers: this.getHeaders(), withCredentials: true })
  },

  async getOperationsCartePorteur (credentials) {
    return axios.post('/porteur/operationscarteporteur', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getGestionnaire (credentials) {
    return axios.post('/porteur/getGestionnaire', credentials, { headers: this.getHeadersForDownload(), withCredentials: true })
  }
}
